import {createAsyncThunk} from '@reduxjs/toolkit';
import type {ChangePlanCostArgs, ChangePlanArgs, ValidatePromoCodeArgs, ValidatePromoCodeResponse} from '@Panels/change-plan-modal/change-plan-modal.types';
import {getPromoValidationErrorCode} from '@Libraries/change-subscription-plan-library';

export const initChangePlanModal = createAsyncThunk('initChangePlanModal', async () => {
  return window.PMW.readLocal('premium/getChangeSubscriptionPlanDialog');
});

export const getTeamMembers = createAsyncThunk('getTeamMembers', async () => {
  return window.PMW.readLocal('teams/getTeamMembersForAdmin');
});

export const getChangePlanCost = createAsyncThunk('getChangePlanCost', async (data: ChangePlanCostArgs) => {
  return window.PMW.readLocal('premium/getChangePlanCost', data);
});

export const changePlan = createAsyncThunk('changePlan', async (data: ChangePlanArgs) => {
  return window.PMW.writeLocal('premium/changeSubscriptionPlan', data);
});

export const validatePromoCode = createAsyncThunk<ValidatePromoCodeResponse, ValidatePromoCodeArgs, {rejectValue: string}>(
  'validatePromoCode',
  async ({priceId, promoCode, seats}, {rejectWithValue}) => {
    try {
      return await window.PMW.readLocal('premium/isValidPromotion', {priceId, promoCode, seats, isSeatPurchase: 0});
    } catch (error: unknown) {
      return rejectWithValue(getPromoValidationErrorCode(error));
    }
  }
);

export const cancelPlan = createAsyncThunk('cancelPlan', async () => {
  return window.PMW.writeLocal('premium/cancelSubscription');
});
